import { render } from "./HomePages.vue?vue&type=template&id=5f175dd0"
import script from "./HomePages.vue?vue&type=script&lang=js"
export * from "./HomePages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__